export enum Routes {
  // User routes
  Users = '/users',

  // Facility routes
  Facilities = '/facilities',
  FacilityView = '/facilities/view/:facilityId',

  // Device routes
  Devices = '/devices',
  DeviceView = '/devices/view/:deviceId',

  // Work Order routes
  ServiceRequests = '/work-orders',
  ServiceRequestsArea = '/work-orders/areas',

  // Analytics routes
  AnalyticsRoot = '/analytics',
  Analytics = '/analytics/:dashboardID',

  // Settings routes
  SettingsRoot = '/settings',
  SettingsChangePassword = '/settings/change-password',
  SettingsTeam = '/settings/team',
  SettingsTeamAdd = '/settings/add-partner',
}
